"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var image_1 = __importDefault(require("next/image"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Item = function (_a) {
    var image = _a.image, value = _a.value, description = _a.description;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.itemContainer },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.itemContent },
            react_1.default.createElement(image_1.default, { className: styles_module_scss_1.default.icon, src: image, width: 24, height: 24, alt: description }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, description)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.value }, value)));
};
exports.default = Item;
